import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface ReviewReportRequest {
	reportId: string;
	reportType: string;
	reportCode: string;
	reportContents: string;
}

const key = `useReviewReport`;

const getPath = () => `/bff/portal/reviewReport`;

/** ```
 * 리뷰 신고하기 BFF
 *   `/bff/portal/reviewReport`
 * parameter
 *   `reportId` 리뷰ID
 *   `reportType` 신고하기 타입
 *   `reportCode` 신고하기 코드
 *   `reportContents` 신고하기 내용
 * ```*/
const reviewReportAsync = (data: ReviewReportRequest) => useConfigureAxios({url: getPath(), method: "POST", data});

/** ```
 * 리뷰 신고하기 BFF
 *   `/bff/portal/reviewReport`
 * parameter
 *   `reportId` 리뷰ID
 *   `reportType` 신고하기 타입
 *   `reportCode` 신고하기 코드
 *   `reportContents` 신고하기 내용
 * ```*/
const useReviewReport = (params?: ReviewReportRequest, options?: Partial<UseQueryOptions<Response<null>, Error>>) =>
	useQuery({
		queryKey: [key, getPath()],
		queryFn: () => useConfigureAxios({url: getPath(), method: "POST", params, data: params}).then(r => r.data),
		gcTime: Infinity,
		staleTime: Infinity,
		throwOnError: false,
		...options,
	});

export default useReviewReport;
export {getPath, key, reviewReportAsync};
export type {ReviewReportRequest};
